import { get } from 'lodash/fp'
import { createSelector } from 'reselect'

export const getFna = (state) => state.fna
export const getFnaPhase = createSelector(getFna, get('fnaPhase'))
export const isOnFnaPhase = createSelector(getFnaPhase, (fnaPhase) => fnaPhase)
export const getFnaConfiguration = (state) => state.fnaConfiguration
export const getFnaReasonToSelectProduct = createSelector(
  getFnaConfiguration,
  (fnaConfig) => fnaConfig.reasonToSelectProduct
)

export const getAllVulnerableQuestions = createSelector(
  getFnaConfiguration,
  (fnaConfig) => fnaConfig.newVulnerableQuestions
)

export const getORDVulnerableQuestions = createSelector(
  getFnaConfiguration,
  (fnaConfig) => fnaConfig.ordVulnerableQuestions
)

export const getILPVulnerableQuestions = createSelector(
  getFnaConfiguration,
  (fnaConfig) => fnaConfig.ilpVulnerableQuestions
)

export const getSelectedVulnerableQuestions = createSelector(getFna, get('vulnerableQuestions'))

export const getVenerableQuestions = createSelector(getAllVulnerableQuestions, (allQuestions) => {
  return allQuestions.filter((item) => item.venerable)
})

export const getNonVenerableQuestions = createSelector(getAllVulnerableQuestions, (allQuestions) => {
  return allQuestions.filter((item) => !item.venerable)
})

export const getORDNonVenerableQuestions = createSelector(getORDVulnerableQuestions, (allQuestions) => {
  return allQuestions.filter((item) => !item.venerable)
})

export const getILPNonVenerableQuestions = createSelector(getILPVulnerableQuestions, (allQuestions) => {
  return allQuestions.filter((item) => !item.venerable)
})

export const getSellingMode = createSelector(getFna, get('sellingMode'))
export const getBuyWithAdvisor = createSelector(getFna, get('buyWithAdvisor'))
export const getIsSocial = createSelector(getFna, get('socialMediaC'))
